import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const SearchField = ({ onFilter, value, ...props }) => {
  const [localValue, setLocalValue] = useState(value);
  const [searchTimeout, setSearchTimeout] = useState();

  const handleChange = ({ target: { value } }) => {
    clearTimeout(searchTimeout);
    setLocalValue(value);
    const trimmedVal = value.trim();
    if (trimmedVal || trimmedVal === '')
      setSearchTimeout(
        setTimeout(() => {
          onFilter('search', trimmedVal);
        }, 500),
      );
  };

  const handleReset = () => {
    const blank = '';
    onFilter('search', blank);
    setLocalValue(blank);
  };

  return (
    <TextField
      value={localValue}
      variant="outlined"
      size="small"
      label={props.label ? props.label : 'Search'}
      onChange={handleChange}
      InputProps={{
        endAdornment: localValue && <ClearButton onClick={handleReset} />,
      }}
      className={classNames(localValue ? css.active : '', css.search, props.className)}
    />
  );
};

export default SearchField;
